import React from 'react';

const usePerPageCount = (params, defaultValue, possiblePerPageCount, onUpdate) => {
    const perPageCount = React.useMemo(() => {
        const perPageCountInParams = parseInt(params.per_page) || defaultValue;
        if (!possiblePerPageCount.includes(perPageCountInParams)) {
            return possiblePerPageCount[0];
        }
        return perPageCountInParams;
    }, [params.per_page, defaultValue, possiblePerPageCount]);
    const setPerPageCount = React.useCallback(
        newPerPage => {
            if (perPageCount === newPerPage) {
                return;
            }
            return onUpdate(newPerPage);
        },
        [perPageCount, onUpdate]
    );
    return [perPageCount, setPerPageCount];
};

export default usePerPageCount;
